const areaHk = {
  area: {
    selectArea: "選擇區域",
    HongKong: "中國香港",
    Singapore: "新加坡",
    Macau: "中國澳門",
    China: "中國大陸",
    Japan: "日本",
    Korea: "韓國",
    Thailand: "泰國",
  },
};

export default areaHk;
